export type NectarProjectType = 'AUDIO_RECORDING' | 'VOICE_CONVERSATION' | 'PROFICIENCY_ASSESSMENT'

export const NECTAR_TYPE_TEXT_MAP: Record<string, string> = {
  AUDIO_RECORDING: 'Audio Recording',
  VOICE_CONVERSATION: 'Voice Conversation',
  PROFICIENCY_ASSESSMENT: 'Proficiency Assessment'
}

export type CefrLevel = 'A1' | 'A2' | 'B1' | 'B2' | 'C1' | 'C2'

export type ProficiencyAssessmentFinalResult = {
  level: CefrLevel
  numericScore: number
  confidence: 'low' | 'medium' | 'high'
  signals: { selfAssessment: CefrLevel; textTest: CefrLevel; speechTest: CefrLevel }
}

export type ProficiencyAssessment = {
  id: string
  status: 'IN_PROGRESS' | 'COMPLETED' | 'FAILED'
  finalResult: ProficiencyAssessmentFinalResult | null
  expiresAt: string | null
  createdAt: string
}

export type TextQuestion = {
  id: string
  prompt: string
  options: { text: string }[]
  timeLimitSec: number | null
}

export type SpeechQuestion = {
  id: string
  prompt: string
  audioUrl: string
}

export type NectarProjectStatus = 'DRAFT' | 'ACTIVE' | 'COMPLETED' | 'ARCHIVED'
export type NectarEnrollmentStatus = 'IN_PROGRESS' | 'PENDING_REVIEW' | 'APPROVED' | 'REJECTED' | 'EXPIRED'

export type NectarRewardConfig = {
  type: string
  amount: number
} | null

export type NectarProject = {
  id: string
  name: string
  type: NectarProjectType
  description: string | null
  rules: string | null
  language: string
  status: NectarProjectStatus
  maxTasksPerUser: number
  maxSubmissionsPerTask: number
  approvalThreshold: number
  assignmentTtlHours: number | null
  rewardConfig: NectarRewardConfig
  createdAt: string
  updatedAt: string
  enrolled: boolean
  progress: { completed: number; total: number }
  enrollment: { id: string; status: NectarEnrollmentStatus; earnedReward: number | null } | null
  enrolledUsersCount: number
  sortOrder: number
  availability: { available: boolean; reason: 'unavailable' | 'profile_required' }
}

export type NectarTask = {
  id: string
  instruction: string
  type: string
  params: Record<string, unknown>
  metadata: Record<string, unknown> | null
  projectId: string
  createdAt: string
  updatedAt: string
  submissionCount: number
}

export type PaginatedResponse<T> = {
  data: T[]
  meta: { total: number; page: number; limit: number }
}

export type EnrollResponse = {
  projectId: string
  enrollmentId: string
  assignedCount: number
}
